import React from 'react';
import { UI_SCREEN_STYLES } from '../../styles/UISystem';
import IconBack from '../../components/UISystem/Icons/IconBack';
import ConnectionCard from '../../components/UI/Cards/ConnectionCard';

/**
 * Cards Screen
 *
 * Showcases various card components in the UI system
 */
const CardsScreen = ({ onBack }) => {
  return (
    <div style={UI_SCREEN_STYLES.container}>
      {/* Header with back button and title */}
      <div style={UI_SCREEN_STYLES.header}>
        <IconBack onClick={onBack} />
        <h1 style={UI_SCREEN_STYLES.title}>Cards</h1>
      </div>
      <div style={UI_SCREEN_STYLES.divider} />

      <section style={{ marginBottom: '40px' }}>
        <h2>Connection Card</h2>
        <p>Used to display connection information in lists and other contexts.</p>

        <div
          style={{
            border: '1px solid #eee',
            borderRadius: '8px',
            overflow: 'hidden',
            marginBottom: '20px',
            width: '100%',
            maxWidth: '600px',
          }}
        >
          <ConnectionCard
            name="Yasmine Aria"
            location="Williamsburg @ Gran Torino"
            note="Add to note"
            photoUrl="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80"
            timestamp="Today"
            onClick={() => alert('Card clicked')}
          />
        </div>

        <div
          style={{
            border: '1px solid #eee',
            borderRadius: '8px',
            overflow: 'hidden',
            marginBottom: '20px',
            width: '100%',
            maxWidth: '600px',
          }}
        >
          <ConnectionCard
            name="Franz Gruber"
            location="Williamsburg @ Gran Torino"
            note="Met at the coffee shop"
            photoUrl="https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80"
            timestamp="Yesterday"
            onClick={() => alert('Card clicked')}
          />
        </div>

        <div
          style={{
            border: '1px solid #eee',
            borderRadius: '8px',
            overflow: 'hidden',
            width: '100%',
            maxWidth: '600px',
          }}
        >
          <ConnectionCard
            name="Alex Morgan"
            location="Bushwick @ House of Yes"
            onClick={() => alert('Card clicked')}
          />
        </div>

        <h3>Usage</h3>
        <pre
          style={{
            backgroundColor: '#f5f5f5',
            padding: '15px',
            borderRadius: '4px',
            overflowX: 'auto',
          }}
        >
          {`import ConnectionCard from '../UI/Cards/ConnectionCard';

<ConnectionCard 
  name={&quot;Yasmine Aria&quot;}
  location={&quot;Williamsburg @ Gran Torino&quot;}
  note={&quot;Add to note&quot;}
  photoUrl={&quot;https://example.com/photo.jpg&quot;}
  timestamp={&quot;Today&quot;}
  onClick={() => handleCardClick()}
/>`}
        </pre>

        <h3>Props</h3>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid #ddd' }}>
              <th style={{ textAlign: 'left', padding: '8px' }}>Prop</th>
              <th style={{ textAlign: 'left', padding: '8px' }}>Type</th>
              <th style={{ textAlign: 'left', padding: '8px' }}>Required</th>
              <th style={{ textAlign: 'left', padding: '8px' }}>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '8px' }}>name</td>
              <td style={{ padding: '8px' }}>string</td>
              <td style={{ padding: '8px' }}>Yes</td>
              <td style={{ padding: '8px' }}>The name of the connection</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '8px' }}>location</td>
              <td style={{ padding: '8px' }}>string</td>
              <td style={{ padding: '8px' }}>Yes</td>
              <td style={{ padding: '8px' }}>The formatted location string</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '8px' }}>note</td>
              <td style={{ padding: '8px' }}>string</td>
              <td style={{ padding: '8px' }}>No</td>
              <td style={{ padding: '8px' }}>
                Optional note text (defaults to &quot;Add to note&quot;)
              </td>
            </tr>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '8px' }}>photoUrl</td>
              <td style={{ padding: '8px' }}>string</td>
              <td style={{ padding: '8px' }}>No</td>
              <td style={{ padding: '8px' }}>
                URL for profile photo (shows first letter if not provided)
              </td>
            </tr>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '8px' }}>timestamp</td>
              <td style={{ padding: '8px' }}>string</td>
              <td style={{ padding: '8px' }}>No</td>
              <td style={{ padding: '8px' }}>
                Optional timestamp to display (defaults to &quot;Today&quot;)
              </td>
            </tr>
            <tr>
              <td style={{ padding: '8px' }}>onClick</td>
              <td style={{ padding: '8px' }}>function</td>
              <td style={{ padding: '8px' }}>Yes</td>
              <td style={{ padding: '8px' }}>Click handler for the card</td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>
  );
};

export default CardsScreen;
